import {API_URL, fetchWithHandling} from "./api"
export const WORKFLOW_API_URL = API_URL

// Function to create a workflow
export const createWorkflow = async (accessToken, nodes, edges, title, description, apps, selectedDataSourceFileIds, globalState, global_state_data) => {

    const workflowData = {nodes, edges, title, description, apps_expanded: apps, data_sources:selectedDataSourceFileIds, globalState, global_state: global_state_data};
    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/createWorkflow`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        
          'Authorization':`Bearer ${accessToken}`
        
      },
      body: JSON.stringify(workflowData),
    });
};

// Function to modify a workflow
export const modifyWorkflow = async (accessToken, workflowId, nodes, edges, title, description, apps, selectedDataSourceFileIds, globalState, global_state_data) => {
  const workflowData = { nodes, edges, title, description, apps_expanded: apps, data_sources: selectedDataSourceFileIds, globalState, global_state: global_state_data }

    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/modifyWorkflow/${workflowId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        
          'Authorization':`Bearer ${accessToken}`
        
      },
      body: JSON.stringify(workflowData),
    });
};

// Function to get all workflows for a user
export const getWorkflows = async (accessToken) => {

    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/getWorkflows`, {headers: {
      'Authorization':`Bearer ${accessToken}`
    },});
};

// --- MODIFIED updateWorkflow function ---
/**
 * Updates a specific workflow, typically for changing its status.
 * @param {string} workflowId - The ID of the workflow to update.
 * @param {object} payload - The data to update (e.g., { disabled: true }).
 * @param {string} accessToken - The user's JWT for authorization.
 * @returns {Promise<object>}
 */
export const updateWorkflow = async (workflowId, payload, accessToken) => {
  return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/modifyWorkflowStatus/${workflowId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });
};

// Function to get a specific workflow by ID
export const getSpecificWorkflow = async (workflowId, accessToken, executionId) => {

    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/getWorkflow/${workflowId}?execution_id=${executionId || ""}`, {headers: {
      'Authorization':`Bearer ${accessToken}`
    },});

};

export const saveWorkflowDraft = async (accessToken, nodes, edges, title, description, apps, selectedDataSourceFileIds) => {

    const data = { nodes, edges, title, description, apps_expanded: apps, data_sources: selectedDataSourceFileIds};
    console.log("Data sent:", data)
    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/saveWorkflowDraft`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        
          'Authorization':`Bearer ${accessToken}`
        
      },
      body: JSON.stringify(data), // 'data' contains the workflow draft information
    });
};

export const getWorkflowDraft = async (accessToken) => {
  return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/getWorkflowDraft`, {headers: {
      'Authorization':`Bearer ${accessToken}`
    },});
    
};

// ------------------------------------------- WORKFLOW EXECUTION ----------------------------------------
// Function to execute a workflow and get the execution ID
export const executeWorkflow = async (workflowId, accessToken) => {

  return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/executeWorkflow/${workflowId}`, {
      method: "POST",
      headers: {
        'Authorization':`Bearer ${accessToken}`
      },
    });

    
};

// WebSocket connection for real-time workflow execution updates
export const connectToExecutionSocket = (executionId, onMessageCallback) => {
  const socket = new WebSocket(`ws://your-backend-url.com/canvas/ws/executeWorkflow/${executionId}`);

  socket.onopen = () => {
    console.log("WebSocket connected for execution updates.");
  };

  socket.onmessage = (event) => {
    const message = JSON.parse(event.data);
    onMessageCallback(message);  // Callback to handle the received status updates
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  socket.onclose = () => {
    console.log("WebSocket connection closed.");
  };

  return socket;
};

// ---------------------------- AI Workflow Generation -----------------------------------
export const submitWorkflowAndGetClarificationQuestions = async (accessToken, workflow_instructions, workflow_title, triggers, apps, selected_data_source_file_ids, selected_file_ids) => {

    const data = {workflow_instructions, workflow_title, triggers, apps, selected_data_source_file_ids, selected_file_ids};
    console.log("Data sent:", data)
    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/submitWorkflowAndGetClarificationQuestions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        
          'Authorization':`Bearer ${accessToken}`
        
      },
      body: JSON.stringify(data), // 'data' contains the workflow draft information
    });

};

export const submitClarificationAndCreateWorflow = async (accessToken, workflow_id, clarification_questions) => {

    console.log("Workflow ID", workflow_id)
    const data = { workflow_id, clarification_questions};
    console.log("Data sent:", data)
    return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/clarifyAndCreateWorkflow`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
       
          'Authorization':`Bearer ${accessToken}`
        
      },
      body: JSON.stringify(data), // 'data' contains the workflow draft information
    });
    
};

// Function to get a specific workflow by ID
export const getExecutionHistory = async (workflowId, accessToken) => {

  return fetchWithHandling(`${WORKFLOW_API_URL}/canvas/executions/${workflowId}`, {headers: {
    'Authorization':`Bearer ${accessToken}`
  },});

};

export const fetchWorkflowExecutionsCurrent = async (accessToken) => {
  const url = `${WORKFLOW_API_URL}/canvas/workflow/executions`;
  
  const options = {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  };
  return fetchWithHandling(url, options);
};

/**
 * Fetches a list of notifications for the user with pagination.
 * @param {string} accessToken - The user's JWT for authorization.
 * @param {object} options - Optional parameters for fetching notifications.
 * @param {boolean} [options.active_only=true] - Whether to fetch only active notifications.
 * @param {number} [options.skip=0] - The number of notifications to skip (for pagination).
 * @param {number} [options.limit=20] - The maximum number of notifications to return.
 * @returns {Promise<{notifications: Array<object>}>} A promise that resolves to the API response containing the list of notifications.
 */
export const getNotifications = async (accessToken, options = {}) => {
  // Set default values for the optional parameters
  const { active_only = true, skip = 0, limit = 20 } = options;

  // Use URLSearchParams to easily construct the query string
  const params = new URLSearchParams({
    active_only,
    skip,
    limit,
  });

  // Construct the final URL
  const url = `${API_URL}/notifications/?${params.toString()}`;

  // Make the API call using your existing fetchWithHandling wrapper
  return fetchWithHandling(url, {
    method: "GET",
    headers: {
      // The Authorization header is required by the backend endpoint
      'Authorization': `Bearer ${accessToken}`,
    },
  });
};

/**
 * Fetches the full, processed details for a single meeting notification.
 * @param {string} accessToken - The user's JWT for authorization.
 * @param {string} eventId - The unique ID of the meeting event.
 * @returns {Promise<object>} A promise that resolves to the complete notification object.
 */
export const getMeetingDetails = async (accessToken, eventId) => {
  const url = `${API_URL}/notifications/meeting/${eventId}`;

  return fetchWithHandling(url, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });
};

/**
 * Fetches the full, processed details for a single meeting notification.
 * @param {string} accessToken - The user's JWT for authorization.
 * @param {string} eventId - The unique ID of the meeting event.
 * @returns {Promise<object>} A promise that resolves to the complete notification object.
 */
export const getUserConfiguredMeetingDetails = async (accessToken, eventId) => {
  const url = `${API_URL}/notifications/manual-meeting/${eventId}`;

  return fetchWithHandling(url, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });
};

/**
 * Submits approval decisions for a specific workflow node.
 * @param {string} accessToken - The user's JWT for authorization.
 * @param {string} executionId - The ID of the workflow execution.
 * @param {string} nodeId - The ID of the node requiring approval.
 * @param {object} decisions - The approval decisions object.
 * @returns {Promise<object>}
 */
export const submitWorkflowApproval = async (accessToken, executionId, nodeId, decisions) => {
  const payload = { approvalNeededTools: decisions };
  
  const url = `${API_URL}/canvas/workflow/executions/${executionId}/nodes/${nodeId}/approval-update`;

  return fetchWithHandling(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });
};